import styled from "styled-components";

// tslint:disable-next-line
export const InputText = styled.input`
  padding: 5px;
`;
